import { GridResizeEventName } from './grid-resize.service';

export class GridResizeEvent<TData> {
    public name: GridResizeEventName;
    public value: TData;
    public viewport: Element;

    public constructor(name: GridResizeEventName, value: TData, viewport: Element) {
        this.name = name;
        this.value = value;
        this.viewport = viewport;
    }
}
